<template>
  <div class="navigation-header-box">
    <div class="logo" @click="handleJumpToHome">
      <!-- <a href="/"> -->
      <img
        src="https://talbook-cdn.oss-cn-beijing.aliyuncs.com/xueersi_web/web/home/logo.png"
        alt=""
      />
      <!-- </a> -->
    </div>
    <div class="nav-list">
      <div class="nav-list-left" :class="{ transparent: transparent }">
        <div
          class="nav-list-item"
          :class="{ active: nav.url === route.path }"
          v-for="(nav, key) in navLeftList"
          @click="navigation(nav.url)"
          :key="key"
        >
          <div>{{ nav.text }}</div>
        </div>
      </div>

      <div class="nav-list-right" :class="{ transparent: transparent }">
        <div class="nav-list-item">
          <div class="icon"></div>
          <div>全部产品</div>
          <div class="drop-menu">
            <DropMenu />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import DropMenu from "./DropMenu.vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();

defineProps({
  transparent: { type: Boolean, required: false },
});
const navLeftList = [
  {
    text: "首页",
    url: "/",
  },
  {
    text: "学习机",
    url: "https://xpad.xueersi.com?source_id=61",
  },
  {
    text: "学而思网校",
    url: "https://online.xueersi.com/",
  },
  {
    text: "培优素养课",
    url: "https://www.speiyou.com/home",
  },
  {
    text: "智能图书",
    url: "/ibook",
  },
  {
    text: "九章大模型",
    url: "https://www.mathgpt.com/",
  },
  {
    text: "我们的故事",
    url: "/story",
  },
];
const navigation = (url) => {
  if (url === "/") {
    router.push("/");
  } else if (url === "/story") {
    router.push("/story");
  } else if (url === "/ibook") {
    router.push("/ibook");
  } else {
    window.open(url, "_blank");
  }
};

const handleJumpToHome = () => {
  router.push("/");
};
</script>
<style lang="less" scope>
.navigation-header-box {
  height: 78px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1250px;
  margin: 0 auto;
  .logo {
    width: 97px;
    height: 30px;
    margin-right: 50px;
    padding-left: 10px;
    cursor: pointer;
    img {
      width: 100%;
    }
  }
  .nav-list {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    .nav-list-item {
      display: flex;
      align-items: center;
      position: relative;
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      margin-right: 46px;
      padding: 11px 0;
      cursor: pointer;
      white-space: nowrap;
      color: #333;
      position: relative;
      a {
        color: #333;
        text-decoration: none;
        outline: none;
      }
      .drop-menu {
        // padding-top: 70px;
        display: none;
        position: absolute;
        right: -30px;
        top: 36px;
      }
      .icon {
        width: 18px;
        height: 18px;
        margin-right: 6px;
        background: url("https://editor.xesimg.com/tailor/resource/Group11-1702365038499.png");
        background-size: 100% 100%;
      }
      &:hover {
        color: #ec2226;
        .icon {
          background-image: url("https://editor.xesimg.com/tailor/resource/allSelect-1702365038497.png");
        }
        .drop-menu {
          display: flex;
        }
      }
      &.active {
        color: #ec2226;
        &::after {
          content: " ";
          background: #e02727;
          border-radius: 16px;
          width: 32px;
          height: 3px;
          position: absolute;
          bottom: 0;
          left: 50%;
          margin-left: -16px;
          margin-bottom: -8px;
        }
      }
    }
  }
  .nav-list-left {
    display: flex;
  }
}
</style>
